// Public host for mirrored creator media (avatars, banners, thumbnails, game art).
// Backblaze B2 behind Cloudflare; keys are `{platform}/{directory}/{id}`.
export const MEDIA_CDN_BASE = (import.meta.env.VITE_APP_MEDIA_CDN_BASE || 'https://media.streamforge.com').replace(/\/+$/, '')

export const MEDIA_CDN_HOST = new URL(MEDIA_CDN_BASE).host
